import { STATUS } from "@/constants/statuses";
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import type { RewardsHistoryEntity } from "../RewardsHistoryEntities";

export interface RewardsHistoryStoreState
    extends EntityState<RewardsHistoryEntity, number> {
    paginationMeta: {
        currentOffset: number;
        perPage: number;
        totalCount: number;
    };
    status: STATUS;
}

const createInitialState = (): RewardsHistoryStoreState => ({
    paginationMeta: {
        currentOffset: 0,
        perPage: 0,
        totalCount: 0,
    },
    status: STATUS.VIRGIN,
});

@singleton()
@StoreConfig({ name: "RewardsHistoryStore" })
class RewardsHistoryStore extends EntityStore<RewardsHistoryStoreState> {
    constructor() {
        super(createInitialState());
    }

    setStatus(status: STATUS): void {
        this.update((state) => ({ ...state, status }));
    }
}

export default RewardsHistoryStore;
